import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LegalFooter from './LegalFooter.jsx';
import '../styles/mainPage.css';

const SignupSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { email, isNewUser = true } = location.state || {};
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate('/');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    return (
        <div className="container" style={{ minHeight: '100vh', position: 'relative', background: 'transparent' }}>
            {/* Header */}
            <header style={{ position: 'fixed', top: 0, left: 0, right: 0, padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 20, background: 'transparent' }}>
                <span style={{ fontWeight: 700, fontSize: '1.5rem', color: '#fff', letterSpacing: '-1px', cursor: 'pointer' }} onClick={() => navigate('/')}>LiveNow</span>
            </header>
            
            <div style={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ width: '100%', maxWidth: 600, background: 'rgba(15,23,42,0.65)', borderRadius: 28, padding: '2.2rem 2.2rem', boxShadow: '0 8px 32px rgba(0,0,0,0.13)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
                    
                    {isNewUser ? (
                        <>
                            <h2 style={{ color: '#fff', fontWeight: 900, fontSize: '2.2rem', marginBottom: 2, textAlign: 'center', letterSpacing: '-1px', lineHeight: 1.1 }}>Welcome to LiveNow!</h2>
                            <p style={{ color: '#b6c6e3', fontSize: '0.98rem', marginBottom: 14, textAlign: 'center', fontWeight: 400, maxWidth: 520, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.3 }}>
                                Your account has been created successfully. You're now ready to catch every live moment!
                            </p>
                        </>
                    ) : (
                        <>
                            <h2 style={{ color: '#fff', fontWeight: 900, fontSize: '2.2rem', marginBottom: 2, textAlign: 'center', letterSpacing: '-1px', lineHeight: 1.1 }}>Welcome back!</h2>
                            <p style={{ color: '#b6c6e3', fontSize: '0.98rem', marginBottom: 14, textAlign: 'center', fontWeight: 400, maxWidth: 520, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.3 }}>
                                You've successfully signed in. Ready to catch up on the latest live content?
                            </p>
                        </>
                    )}
                    
                    {email && (
                        <div style={{ background: 'rgba(30,41,59,0.95)', color: '#fff', border: '1.5px solid #10b981', borderRadius: 10, padding: '0.6rem 1rem', margin: '0 0 8px 0', display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.97rem', fontWeight: 500, boxShadow: '0 2px 8px 0 rgba(16,185,129,0.08)', maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/></svg>
                            Signed in as {email}
                        </div>
                    )}
                    
                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                        <p style={{ color: '#b6c6e3', fontSize: '0.9rem', marginBottom: 8 }}>
                            Redirecting to main page in {countdown} second{countdown !== 1 ? 's' : ''}...
                        </p>
                        <Link to="/" className="livenow-signup-btn" style={{ fontSize: '0.97rem', padding: '0.6rem 1.1rem', maxWidth: 360, width: '100%', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', textDecoration: 'none' }}>
                            {isNewUser ? 'Start Exploring Now' : 'Continue to App Now'}
                        </Link>
                    </div>
                    
                    <div style={{ textAlign: 'center', marginTop: 6 }}>
                        <Link to="/" style={{ color: '#b6c6e3', fontSize: '0.92rem', textDecoration: 'underline' }}>Back to Home</Link>
                    </div>
                </div>
            </div>
            <LegalFooter />
        </div>
    );
};

export default SignupSuccess; 